export enum SearchRangeTerms {
  Today = 'Today',
  Yesterday = 'Yesterday',
  LastSevenDays = 'Last 7 Days',
  LastThirtyDays = 'Last 30 Days',
  ThisMonth = 'This Month',
  LastMonth = 'Last Month',
  CustomRange = 'Custom Range',
}
